import { useState, useMemo, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCartQuery, useRemoveFromCart } from "../../hooks/useCart";
import { usePopup } from "../../hooks/usePopup";

export const useShoppingCart = () => {
  const navigate = useNavigate();
  const [filtered, setFiltered] = useState<string | undefined>();
  const [searchParams] = useSearchParams();
  const { data } = useCartQuery();
  const cartItemsAll: SelectableBooking[] = useMemo(() => data ?? [], [data]);
  const [delSingle, setDelSingle] = useState<string | null>(null);

  const popupDel = usePopup({
    onOk: () => {
      if (delSingle) {
        removeFromCart.mutate(items.filter((x) => x.id === delSingle));
      } else {
        // removeFromCart.mutate(items.filter((x) => x.checked));
        removeFromCart.mutate(items);
      }
    },
    onClose: () => {
      setDelSingle(null);
    },
  });

  const removeFromCart = useRemoveFromCart({
    onSettled: () => {
      setDelSingle(null);
    },
  });

  useEffect(
    function () {
      if (!delSingle) return;
      popupDel.open();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [delSingle],
  );

  // TODO: filter card by staus, following example
  const [items, setItems] = useState<SelectableBooking[]>([]);
  useEffect(() => {
    setItems(cartItemsAll);
  }, [cartItemsAll]);

  // Event handlers
  const onSelectCardGroup = (productType: string, checked: boolean) => {
    setItems((prev) => {
      return prev.map((item) => {
        if (item.product?.productType === productType) {
          item.checked = checked;
        }
        return item;
      });
    });
  };

  const onSelectAll = (checked: boolean) => {
    setItems((prev) => {
      return prev.map((item) => {
        item.checked = checked;
        return item;
      });
    });
  };

  const onRemoveItems = () => {
    // removeFromCart.mutate(items.filter((x) => x.checked));
    popupDel.open();
  };

  const onSelectItem = (card: BookingState, checked: boolean) => {
    setItems((prev) => {
      return prev.map((item) => {
        if (item === card) {
          item.checked = checked;
        }
        return item;
      });
    });
  };

  // Renders a list of product cards
  const onBookNow = () => {
    const ids = items.filter((x) => x.checked).map((x) => x.id);
    console.log(ids);
    if (!ids.length) return;
    if (searchParams.get("upgrade")) {
      // navigate("/shopping-cart/order?upgrade=true&bookIds=" + ids.join(","));
      navigate("/shopping-cart?upgrade=true&bookIds=" + ids.join(","));
    } else {
      // navigate("/shopping-cart/order?bookIds=" + ids.join(","));
      navigate("/shopping-cart?bookIds=" + ids.join(","));
    }
  };
  return {
    items,
    onSelectCardGroup,
    onSelectAll,
    onRemoveItems,
    onBookNow,
    filtered,
    setFiltered,
    cartItemsAll,
    onSelectItem,
    popupDel,
    setDelSingle,
  };
};
